var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource_tree"},[_c('el-tree',{ref:"resTree",attrs:{"default-checked-keys":[_vm.parentId],"data":_vm.treeData,"props":_vm.defaultProps,"node-key":"id","accordion":_vm.accordion,"highlight-current":true,"default-expanded-keys":_vm.expandedKeys},on:{"node-click":_vm.nodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26eefe7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/resourceTree/src/main.vue
// module id = null
// module chunks = 